export default [
    {
        path: '/pages/property/downloadTempFile',
        name: '/pages/property/downloadTempFile',
        meta: { title: '下载中心' },
        component: () => import('@/views/property/downloadTempFile.vue')
    }
] 